import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Radio,
    FormControlLabel,
    RadioGroup,
    Slide,
    IconButton,
    TextField,
    InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import { getMachineLocations } from "../../Services/authService";
import { useThemeContext } from "../../Context/ThemeContext";
import { DARKCOLORS, LIGHTCOLORS } from "../../Utils/constants";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} timeout={800} />;
});

const LocationPopup = ({ open, onClose, selectedMachine, onSubmit }) => {
    const { t } = useTranslation();
    const { mode } = useThemeContext();
    const [locations, setLocations] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [selectedMachineId, setSelectedMachineId] = useState(selectedMachine || "");
    const [searchQuery, setSearchQuery] = useState("");

    const modalBackgroundColor = mode === "dark" ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
    const textColor = mode === "dark" ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
    const searchBackground = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const dividerColor = mode === 'dark' ? DARKCOLORS.Primary100 : LIGHTCOLORS.Primary100;
    const btnColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const data = await getMachineLocations();
                setLocations(data);
                setFilteredLocations(data);
            } catch (error) {
                console.error(t("locationPopup.errorFetchingLocations"), error);
            }
        };
        fetchLocations();
    }, []);

    useEffect(() => {
        if (selectedMachine) {
            // Find the machine object that matches the given machine number
            const matchingMachine = locations
                .flatMap((location) => location.machines)
                .find((machine) => machine.machineNo === selectedMachine);

            if (matchingMachine) {
                setSelectedMachineId(matchingMachine.machineId);
            }
        }
    }, [selectedMachine, locations]); // Runs when selectedMachine or locations update

    const handleMachineSelect = (machineId) => {
        setSelectedMachineId(machineId);
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);
        const filtered = locations.filter(
            (loc) =>
                loc.city.toLowerCase().includes(query) ||
                loc.machines.some((machine) =>
                    `${machine.machineNo} ${machine.street}`.toLowerCase().includes(query)
                )
        );
        setFilteredLocations(filtered);
    };

    const handleSubmit = () => {
        const selectedMachineDetails = locations
            .flatMap((location) => location.machines)
            .find((machine) => machine.machineId == selectedMachineId);
        onSubmit(selectedMachineDetails);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            TransitionComponent={Transition}
            PaperProps={{
                sx: {
                    position: "absolute",
                    right: 50,
                    margin: 0,
                    width: "350px",
                    maxHeight: "70vh",
                    borderRadius: 3,
                    background: modalBackgroundColor,
                    "@media (max-width: 427px)": {
                        right: 5,
                        width: "300px",
                    },
                },
            }}
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 2, px: 2 }}>
                <button type="button" style={{ background: btnColor, padding: "10px 15px", fontSize: "13px" }} className='save-btn' onClick={handleSubmit}>{t('membershipCards.save')}</button>
                <IconButton onClick={onClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 3 }}>
                <TextField
                    placeholder={t("membershipCards.search")}
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ borderRadius: "24px", background: searchBackground, width: "100%", marginBottom: 10 }}
                    size="small"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                border: "none",
                            },
                        },
                    }}
                />

                <RadioGroup value={selectedMachineId} onChange={(e) => handleMachineSelect(e.target.value)}>
                    {filteredLocations.map((location, index) => (
                        <Box key={index}>
                            <p className="popup-text" style={{ padding: "15px 0px 5px", margin: 0, borderTop: `1px solid ${dividerColor}` }}>{location.city}</p>
                            {location.machines.map((machine) => (
                                <FormControlLabel
                                    key={machine.machineId}
                                    control={<Radio value={machine.machineId} />}
                                    // label={`${machine.location} – ${machine.machineNo}`}
                                    label={
                                        <span title={`${machine.location} – ${machine.machineNo}`}>
                                            {machine.location} – {machine.machineNo}
                                        </span>
                                    }
                                    className="add-machine"
                                    sx={{ color: textColor, display: "block" }}
                                />
                            ))}
                        </Box>
                    ))}
                </RadioGroup>
            </DialogContent>
        </Dialog>
    );
};

export default LocationPopup;
